/* Soulsane Beauty — theme interactions */
(function () {
  'use strict';

  /* ---- Scroll reveal ---- */
  const revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('revealed'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('revealed'));
  }

  /* ---- Mobile menu ---- */
  const menuToggle = document.querySelector('[data-menu-open]');
  const mobileMenu = document.querySelector('.mobile-menu');
  const menuClose = document.querySelector('[data-menu-close]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => mobileMenu.classList.add('open'));
    if (menuClose) menuClose.addEventListener('click', () => mobileMenu.classList.remove('open'));
  }

  /* ---- Cart drawer ---- */
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  const openers = document.querySelectorAll('[data-cart-open]');
  const closers = document.querySelectorAll('[data-cart-close]');
  function openDrawer(e) {
    if (!drawer) return;
    if (e) e.preventDefault();
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    refreshDrawer();
  }
  function closeDrawer() {
    if (drawer) drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
  }
  openers.forEach((b) => b.addEventListener('click', openDrawer));
  closers.forEach((b) => b.addEventListener('click', closeDrawer));
  if (overlay) overlay.addEventListener('click', closeDrawer);

  async function refreshDrawer() {
    const body = document.querySelector('[data-drawer-body]');
    if (!body) return;
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      if (!cart.items.length) {
        body.innerHTML = '<p style="color:var(--ink-soft)">Your cart is empty.</p>';
        return;
      }
      let html = '';
      cart.items.forEach((it) => {
        const img = it.image ? `<img src="${it.image}" alt="" style="width:64px;height:80px;object-fit:cover;border-radius:2px">` : '';
        html += `<div style="display:flex;gap:1rem;padding:1rem 0;border-bottom:1px solid var(--line)">${img}
          <div style="flex:1"><div style="font-size:.92rem">${it.product_title}</div>
          <div style="font-size:.82rem;color:var(--ink-soft)">Qty ${it.quantity}</div></div>
          <div style="font-size:.9rem">${formatMoney(it.final_line_price)}</div></div>`;
      });
      html += `<div style="margin-top:1.5rem"><a href="/checkout" class="btn btn--block">Checkout · ${formatMoney(cart.total_price)}</a></div>`;
      body.innerHTML = html;
    } catch (err) { /* silent */ }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---- Quantity steppers ---- */
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach((btn) => {
      btn.addEventListener('click', () => {
        let v = parseInt(input.value, 10) || 1;
        v = btn.dataset.step === 'up' ? v + 1 : Math.max(1, v - 1);
        input.value = v;
      });
    });
  });

  /* ---- Product gallery thumbnails ---- */
  const mainMedia = document.querySelector('[data-main-media]');
  if (mainMedia) {
    document.querySelectorAll('[data-thumb]').forEach((t) => {
      t.addEventListener('click', () => { mainMedia.src = t.dataset.full || t.src; });
    });
  }
})();
